import { useState } from "react";
import { Alert, Badge, Button, Col, Container, FloatingLabel, Form, InputGroup, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { MdCheck, MdClose, MdOutlineTipsAndUpdates } from "react-icons/md";
import ExtraWorkAdd from "./ExtraWorksAdd";
import ExtraWorkEdit from "./ExtraWorkEdit";
import { createShiftAsync } from "./api";

export default function ShiftCreate({ jwt, onHide, show, extraWorksAll, machinesAll, categoriesExtraWorksAll, workersAll }) {

    const [isExtraWorksAdd, setIsExtraWorksAdd] = useState(false);
    const [extraWorkEdit, setExtraWorkEdit] = useState();

    const [worker, setWorker] = useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [endMachineDate, setEndMachineDate] = useState(new Date());
    const [startMachineDate, setStartMachineDate] = useState(new Date());
    const [extraWorks, setExtraWorks] = useState([]);
    const [isDayOff, setIsDayOff] = useState(false);
    const [isRemathMachines, setIsRemathMachines] = useState(false);
    const [isMathNight, setIsMathNight] = useState(false);
    const [machinePercent, setMachinePercent] = useState(0);
    const [zone, setZone] = useState('');
    const [machines, setMachines] = useState([]);

    const onSubmit = async (e) => {
        e.preventDefault();

        if (!worker) {
            alert('Выберите работника');
            return;
        }

        if (startDate > endDate || startMachineDate > endMachineDate) {
            alert('Дата начала не может быть больше даты окончания');
            return;
        }
        if (endMachineDate > endDate || startMachineDate > startDate) {
            alert('Дата окончания/начала машины не может быть больше даты окончания/начала смены');
            return;
        }
        try {

            const shiftResponse = await createShiftAsync({
                workerId: worker.id,
                startDate: new Date(startDate).addHours(new Date().getTimezoneOffset() / -60).addHours(zone.split(':')[0] * -1).toJSON(),
                endDate: new Date(endDate).addHours(new Date().getTimezoneOffset() / -60).addHours(zone.split(':')[0] * -1).toJSON(),
                startMachineDate: machines.length > 0 ? new Date(startMachineDate).addHours(new Date().getTimezoneOffset() / -60).addHours(zone.split(':')[0] * -1).toJSON() : startDate,
                endMachineDate: machines.length > 0 ? new Date(endMachineDate).addHours(new Date().getTimezoneOffset() / -60).addHours(zone.split(':')[0] * -1).toJSON() : endDate,
                extraWorks: extraWorks.map(work => ({
                    extraWorkId: Number(work.extraWorkId),
                    value: Number(work.value)
                })),
                isDayOff: isDayOff,
                isRemath: isRemathMachines,
                machinePercent: machinePercent / 100,
                zone: zone,
                machineIds: machines,
                isMathNight: isMathNight
            }, jwt);

            console.log(shiftResponse);
            if (!shiftResponse) {
                alert('Ошибка pri создании смены');
                return;
            }

            onHide();

        } catch (error) {
            console.error('Ошибка при создании смены:', error);
            alert('Произошла ошибка при создании смены');
        }
    }

    const addExtraWork = (work) => {
        setExtraWorks([...extraWorks, work]);
        setIsExtraWorksAdd(false);
    }

    const updateExtraWork = (updatedWork) => {
        setExtraWorks(extraWorks.map(w =>
            w.extraWorkId === updatedWork.extraWorkId ? updatedWork : w
        ));
        setExtraWorkEdit(null);
    };

    const removeExtraWork = (workId) => {
        setExtraWorks(extraWorks.filter(w => w.extraWorkId !== workId));
        setExtraWorkEdit(null);
    };

    if (isExtraWorksAdd)
        return <ExtraWorkAdd
            show={isExtraWorksAdd}
            onHide={() => setIsExtraWorksAdd(false)}
            extraWorks={extraWorksAll}
            jwt={jwt}
            categories={categoriesExtraWorksAll}
            onCreated={addExtraWork}
            immediateMode={false}
        />

    if (extraWorkEdit)
        return <ExtraWorkEdit
            extraWork={extraWorkEdit}
            show={!!extraWorkEdit}
            onHide={() => setExtraWorkEdit(null)}
            onUpdated={updateExtraWork}
            onDeleted={() => removeExtraWork(extraWorkEdit.extraWorkId)}
        />

    return <Modal show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Form onSubmit={onSubmit}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <span>Создание новой смены</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <h5>Время</h5>
                    </Row>
                    <Row>
                        <Col className="mb-3">
                            <FloatingLabel label="Начало" >
                                <Form.Control required type="datetime-local" placeholder="" value={startDate} onChange={e => setStartDate(e.target.value)} />
                            </FloatingLabel>
                        </Col>
                        <Col className="mb-3">
                            <FloatingLabel label="Конец">
                                <Form.Control required type="datetime-local" placeholder="" value={endDate} onChange={e => setEndDate(e.target.value)} />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mb-3">
                            <FloatingLabel label="Начало станков">
                                <Form.Control required type="datetime-local" disabled={machines.length <= 0} placeholder="" value={startMachineDate} onChange={e => setStartMachineDate(e.target.value)} />
                            </FloatingLabel>
                        </Col>

                        <Col className="mb-3">
                            <FloatingLabel label="Окончание станков">
                                <Form.Control required type="datetime-local" disabled={machines.length <= 0} placeholder="" value={endMachineDate} onChange={e => setEndMachineDate(e.target.value)} />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mb-3">
                            <FloatingLabel label="Часовой пояс">
                                <Form.Control required type="time" placeholder="" value={zone} onChange={e => setZone(e.target.value)} />
                            </FloatingLabel>
                            <Form.Text muted>Временно, только положительные часы</Form.Text>
                        </Col>
                    </Row>


                    <Row className="mb-3">
                        <Alert variant="info" style={{ display: "flex", alignItems: 'center' }}>
                            <MdOutlineTipsAndUpdates style={{ marginRight: 6 }} />
                            <span>Что значит по <a href="https://ru.wikipedia.org/wiki/%D0%A1%D1%80%D0%B5%D0%B4%D0%BD%D0%B5%D0%B5_%D0%B2%D1%80%D0%B5%D0%BC%D1%8F_%D0%BF%D0%BE_%D0%93%D1%80%D0%B8%D0%BD%D0%B2%D0%B8%D1%87%D1%83">Гринвичу</a>? Что такое <a href="https://ru.wikipedia.org/wiki/UTC%C2%B10:00">UTC</a>?</span>
                        </Alert>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <h5>Станки</h5>
                            <InputGroup className="mb-3">
                                <InputGroup.Text>Нагрузка</InputGroup.Text>
                                <Form.Control
                                    disabled={isRemathMachines}
                                    type='number'
                                    value={machinePercent}
                                    onChange={e => setMachinePercent(e.target.value)}
                                />
                                <InputGroup.Text>%</InputGroup.Text>
                            </InputGroup>
                            {
                                machinesAll.map(a => <Badge key={a.id}
                                    onClick={() => setMachines(machines.findIndex(f => f == a.id) == -1 ? [...machines, a.id] : [...machines.filter(f => f != a.id)])}
                                    bg={machines.findIndex(f => f == a.id) == -1 ? 'secondary' : 'success'}
                                    pill
                                    style={{ marginRight: 4, transition: '0.4s', cursor: 'pointer' }}>
                                    {machines.findIndex(f => f == a.id) == -1 ? <MdClose style={{ width: 18 }} /> : <MdCheck style={{ width: 18 }} />}
                                    <span style={{ userSelect: 'none' }}>{a.name}</span>
                                </Badge>)
                            }
                            <Form.Select
                                value={worker?.id || ""}
                                onChange={(e) => {
                                    const selectedId = e.target.value;
                                    const selectedWorker = workersAll.find(w => w.id === (selectedId ? Number(selectedId) : null));
                                    setWorker(selectedWorker || null);
                                }}
                                style={{ maxWidth: 300 }}
                            >
                                <option value="">Выберите работника</option>
                                {workersAll.map(w => (
                                    <option key={w.id} value={w.id}>
                                        {`${w.secondName} ${w.firstName}`}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5>Дополнительные работы</h5>
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => setIsExtraWorksAdd(true)}
                            >
                                Добавить
                            </Button>
                        </div>

                        {extraWorks.length > 0 ? (
                            <div className="d-flex flex-wrap gap-2">
                                {extraWorks.map(a => <Badge
                                    key={a.id}
                                    bg={'primary'}
                                    onClick={() => setExtraWorkEdit(a)}
                                    pill
                                    style={{ marginRight: 4, transition: '0.4s', cursor: 'pointer' }}>
                                    <span style={{ userSelect: 'none' }}>{extraWorksAll.find(f => f.id == a.extraWorkId)?.name ?? 'Не найдено'} - {a.value}</span>
                                </Badge>)}
                            </div>
                        ) : (
                            <Alert variant="info">Нет добавленных работ</Alert>
                        )}
                    </Form.Group>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="button-tooltip-info-machines">Выполненные работы станками будут перерасчитаны и определены в текущую смену. ВАЖНО: Если есть другая смена и идет наложение времени, приоритетом будет последняя сохранившееся. Т.к. две смены не могут претендовать одновременно на одну и ту же работу станков</Tooltip>}
                >
                    <Form.Check
                        type="switch"
                        className="me-auto"
                        checked={isRemathMachines}
                        onChange={e => setIsRemathMachines(e.target.checked)}
                        label={'Перерасчет станков'} />
                </OverlayTrigger>
                <Form.Check
                    type="switch"
                    className="me-auto"
                    checked={isDayOff}
                    onChange={e => setIsDayOff(e.target.checked)}
                    label={'Выходной'} />
                <Form.Check
                    type="switch"
                    className="me-auto"
                    checked={isMathNight}
                    onChange={e => setIsMathNight(e.target.checked)}
                    label={'Ночной расчёт'} />
                <Button variant="secondary" onClick={onHide}>Закрыть</Button>
                <Button variant="success" type="submit">Сохранить</Button>
            </Modal.Footer>
        </Form>
    </Modal>
}